import React from 'react';
import Header from '@hoc/partials/Header';

const Layout = ({onSearch, businessData, menu, table, activeForm, selectedCategory, onSelect, scroll, businessSocials, children}) => {
  return (
    <div className="flex-1">
      <Header
        onSearch={onSearch}
        businessData={businessData}
        table={table}
        menu={menu}
        selectedCategory={selectedCategory}
        onSelect={onSelect}
        scroll={scroll}
        activeForm={activeForm}
        />
      <div className="m-3">{children}</div>
    </div>
  );
};

export default Layout;
